class Cookie {
  static set(obj) {
    if (obj && obj.name && obj.value) {
      let cookie_string = `${obj.name}=${obj.value}`;
      let path = obj.path || '/';
      if (obj.expires) {
        const date = new Date();
        let unit = 'day';
        let unitCount = obj.expires;

        const unitRegex = String(obj.expires).match(/[a-zA-Z]+/g);
        if (unitRegex?.[0]) {
          unit = unitRegex[0];
        }

        const unitCountRegex = String(obj.expires).match(/[0-9]+/g);
        if (unitRegex?.[0]) {
          unitCount = parseInt(unitCountRegex[0]);
        }

        switch (unit) {
          case 'min':
            date.setMinutes(date.getMinutes() + unitCount);
            break;
          case 'h':
          case 'hour':
          case 'hours':
            date.setHours(date.getHours() + unitCount);
            break;
          default:
            date.setDate(date.getDate() + unitCount);
        }
        cookie_string += `;expires=${date.toUTCString()}`;
      }
      cookie_string += `;path=${path}`;
      document.cookie = cookie_string;
    }
  }
  static get(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return false;
  }
  static getAll() {
    let cookies = Object.fromEntries(
      document.cookie.split(';').map((cookie) => {
        const [name, val] = cookie.split('=').map((c) => c.trim());
        return [name, val];
      })
    );
    return cookies;
  }
  static remove({ name, path = '/', domain }) {
    if (!name) return;

    let cookieString = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;max-age=0;path=${path}`;
    if (domain) {
      cookieString += `;domain=${domain}`;
    }

    console.log('Removing cookie with string:', cookieString);

    document.cookie = cookieString;
  }
}
export default Cookie;
